import type { IFilterTag } from '../types';
import type { IFlagConfig } from '../configs';

const getFlagTags = <TFilters>(configs: IFlagConfig<TFilters>[], filters: TFilters): IFilterTag[] =>
  configs.flatMap(({ key, label, removable = true }) => {
    const value = filters[key] as boolean | undefined;
    return value ? [{ key: key as string, label, isExclude: false, removable }] : [];
  });

export default getFlagTags;
